import { themeObject } from 'lib';

export const labelStyles = {
    fontWeight: '600',
    '& .MuiFormLabel-asterisk': {
        color: themeObject.palette.tertiary.red[300],
        ml: '-4px',
    },
};
